var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2040_5310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.44595 9.26081H12.7062C14.6052 9.26081 16.15 7.71597 16.15 5.81694C16.15 3.91791 14.6052 2.29653 12.7062 2.29653H9.06498C8.59187 0.960228 7.23957 0.000610352 5.74187 0.000610352C4.19029 0.000610352 2.87641 1.03201 2.44593 2.44454C1.0334 2.87388 0.0020752 4.26543 0.0020752 5.81694C0.0020752 7.71604 1.54685 9.26081 3.44595 9.26081Z",
    fill: "#CC4700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8049 32.3884C36.3385 29.6889 33.9033 27.6284 31.0715 27.6284C28.3003 27.6284 25.9797 29.6037 25.4461 32.2202H21.8878C19.9888 32.2202 18.444 33.765 18.444 35.6641C18.444 37.5631 19.9888 39.1845 21.8878 39.1845H35.7399C37.6389 39.1845 39.1837 37.5631 39.1837 35.6641C39.1837 34.1361 38.1837 32.8379 36.8049 32.3884Z",
    fill: "#FF8E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1411 23.8057C22.9797 23.346 22.5447 23.0378 22.0582 23.0378H16.7219C16.3609 23.0378 16.0201 23.2082 15.8026 23.4974L10.6368 30.3852C10.0711 31.1411 10.6116 32.2215 11.5561 32.2215H13.4485C13.7085 32.2215 13.9619 32.1329 14.1659 31.9704L22.7756 25.0826C23.1568 24.7776 23.3025 24.2653 23.1411 23.8057Z",
    fill: "#CC4700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5921 17.2971H8.75137L4.18618 13.0226C3.97319 12.8185 3.68842 12.7053 3.3947 12.7053H1.14815C0.746821 12.7053 0.376873 12.9138 0.168327 13.2568C-0.0402181 13.5988 -0.0559069 14.0247 0.127996 14.3812L4.31429 22.3206C4.90617 23.4707 6.07885 24.1848 7.37474 24.1848H12.4169L13.9667 22.1187C14.6147 21.2556 15.646 20.741 16.7222 20.741H22.0585C23.869 20.741 25.4914 22.1808 25.4892 24.1848H36.8881C38.1549 24.1848 39.184 23.1546 39.184 21.8889C39.1839 19.3565 37.1234 17.2971 34.5921 17.2971Z",
    fill: "#FF8E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1712 12.1018C14.9627 12.4403 14.9448 12.8629 15.1219 13.2183L16.0132 15.0008H23.9582L19.0814 11.7498C18.8931 11.6242 18.6711 11.5569 18.4447 11.5569H16.1488C15.752 11.5569 15.382 11.7633 15.1712 12.1018Z",
    fill: "#FF8E47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2040_5310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.1837,
    height: 39.1837,
    fill: "white",
    transform: "translate(0.000610352 0.000610352)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.55c9cd9b4a76d7b3ec5ebcb17818b5dc.svg";
export { ForwardRef as ReactComponent };